// =============================================================
// SINGLE SOURCE OF TRUTH for which network the admin panel runs on.
//   "opbnbMainnet" -> production    "opbnbTest" -> internal testing
// =============================================================

import { NETWORKS } from "./networks";
import { CONTRACTS } from "./contracts";

// 🔧 CHOOSE THE NETWORK HERE (in code only):
export const ACTIVE_NETWORK_KEY = "opbnbMainnet";

export const ACTIVE_NETWORK = NETWORKS[ACTIVE_NETWORK_KEY];
export const ACTIVE_CONTRACTS = CONTRACTS[ACTIVE_NETWORK_KEY];

export const USDT_DECIMALS = 18;
export const SCN_DECIMALS = 18;
export const CORE_DECIMALS = 18;

export const APP_NAME = "Smartcore Admin";
